<template>
  <div class="footer">
    <div class="footer-bar">
      <div class="row-fluid footer-nav">
        <ul class="span5 footer-nav-content">
          <li class="f-service">全国服务热线  <b>400-900-1823</b></li>
          <li class="f-company">商务合作：010-62680078</li>
        </ul>
        <ul class="span5 footer-nav-content">

          <li class="f-media">媒体沟通：<a href="mailto:service@bjewaytek.com?subject=媒体沟通"></a>service@bjewaytek.com</li>
          <li class="f-location">总部地址：北京市海淀区知春路9号坤讯大厦5F</li>
        </ul>
        <div class="span2">
          <div class="company-logo"></div>
          <p>关注一维科技</p>
        </div>
      </div>
      <div class="product-test" v-if="showTest">
        <h2 class="product-test__title">产品链接</h2>
        <div class="product-list">
          <span v-for="(item, idx) in products"
                class="product-item"
                :key="idx">
            <span v-if="item.operator" @click="item.operator">{{item.name}}</span>
            <a v-else
               target="_blank"
               :href="item.target">{{item.name}}</a>
          </span>
        </div>
      </div>
      <div class="copyright">北京一维大成科技有限公司 &nbsp;&nbsp;&nbsp; 版权所有 &nbsp;&nbsp;&nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17072044号-1</a></div>
    </div>

    <div class="mb-footer">
      <div class="public-layout-table2">
        <div class="panel-item">
          <dl>
            <dt class="logo">
              北京一维大成科技有限公司
            </dt>
            <dd>
              北京一维大成科技有限公司
            </dd>
            <dd>
              全国服务热线  <em>400-900-1823</em>
            </dd>
          </dl>
        </div>

        <div class="panel-item">
          <dl>
            <dt></dt>
            <dd>关注一维科技</dd>
          </dl>
        </div>
      </div>
      <div class="copyright">北京一维大成科技有限公司 &nbsp;&nbsp; 版权所有 &nbsp;&nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17072044号-1</a></div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showTest: true,
        products: [
          {
            name: '公务员考试',
            target: 'http://h5.kf.bjewaytek.com',
            operator: function () {
              window.open('http://h5.kf.bjewaytek.com', '_blank ', 'width=380,height=620')
            }
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .footer {
    width: 100%;
    padding: 115px 0 12px 0;
    background: #fff;
    .footer-bar {
      @include public_content();
      .footer-nav {
        width: 100%;
        .footer-nav-content {
          li {
            padding-left: 22px;
            background-repeat: no-repeat;
            background-position: left center;
            &.f-service {
              background-image: url('../assets/images/footer/f-i-phe.png');
              font-weight: bold;
              b{
                font-weight: bold;
              }
            }
            &.f-company {
              background-image: url('../assets/images/footer/f-i-mob.png');
            }
            &.f-media {
              background-image: url('../assets/images/footer/f-i-mal.png');
            }
            &.f-location {
              background-image: url('../assets/images/footer/f-i-loc.png');
            }
          }
          li, b {
            line-height: 34px;
            font-size: 12px;
            color: #323232;
            b {
              color: #00ccff;
            }
          }
        }
        .company-logo {
          width: 82px;
          height: 82px;
          background: url('../assets/images/company-logo.png') no-repeat right center;
          -webkit-background-size: contain;
          background-size: contain;
        }
        p{
          width: 82px;
          margin-top: 6px;
          color: #747fa4;
          font-size: 10px;
          text-align: center;
        }
      }
      .product-test {
        font-size: 12px;
        color: #323232;
        line-height: 1.5em;
        .product-test__title {
          font-size: 100%;
          font-weight: bold;
          padding-bottom:6px;
          margin-bottom: 10px;
          border-bottom: 1px solid #efefef;
        }
        .product-list {
          font-size: inherit;
          color: inherit;
          margin-left: -20px;
          @include clear();
          .product-item {
            font-size: inherit;
            color: inherit;
            float: left;
            margin-left: 20px;
            * {
              font-size: inherit;
              color: inherit;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }
      .copyright {
        margin-top: 90px;
        font-size: 12px;
        color: #acacac;
        text-align: center;
        line-height: 1.5em;
        a {
          color: inherit;
          font-size: inherit;
          text-decoration: underline;
        }
      }
    }
    .mb-footer{
      display: none;
    }
  }
  .mobile .footer {
    border-top: 2px solid #eeeeee;
    padding-top: .36rem;
    padding-bottom: .16rem;
    max-width: 7.5rem;

    .footer-bar{
      display: none;
    }

    .mb-footer{
      @include c_wrap();
      display: block;
      color: #323232;
      .panel-item:first-child{
        width: 70%;
        dl{
          padding-left: .16rem;
        }
        dt.logo{
          background: url('../assets/images/theme-logo.png') no-repeat;
          -webkit-background-size: contain;
          background-size: contain;
          font-size: 0;
          height: .58rem;
          margin-bottom: .22rem;
        }
        dd{
          font-size: .22rem;
          margin-bottom: .03rem;
          color: #484848;
          margin-bottom: .22rem;
          em{
            color: #00ccff;
            font-size: .24rem;
            display: inline-block;
            margin-left: .1rem;
            margin-top: .03rem;
            font-weight: lighter;
          }
        }
      }
      .panel-item:last-child{
        width: 30%;
        dl{
          width: 1.42rem;
          margin: 0 auto;
        }
        dt{
          width: 1.42rem;
          height: 1.42rem;
          background: url('../assets/images/code-m.png') no-repeat right top;
          -webkit-background-size: 1.42rem;
          background-size: 1.42rem;
          margin-bottom: .05rem;
        }
        dd{
          font-size: .22rem;
          color: #7d7d7d;
          text-align: center;
          font-weight: lighter;
        }
      }
      .copyright{
        font-size: .22rem;
        color: #d0d0d0;
        text-align: center;
        margin-top: .45rem;
        font-weight: lighter;
        a {
          color: inherit;
          font-size: inherit;
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue